@if (form) {
  <span [formGroup]="form">
    <mat-form-field [ngStyle]="styles" subscriptSizing="dynamic" appearance="fill">
      @if (prefixIcon) {
        <mat-icon matPrefix>{{ prefixIcon }}</mat-icon>
      }
      <mat-label>{{ placeholder }}</mat-label>
      <mat-select [placeholder]="placeholder" [formControlName]="formControlName" (selectionChange)="emitFormEvent($event)" [disabled]="disabled">
        @for (item of items; track trackByItem($index)) {
          <mat-option [value]="item.value">
            {{ item.label }}
          </mat-option>
        }
      </mat-select>
      @if (error) {
        <mat-error [ngStyle]="{ margin: '10px 0' }">{{ error }}</mat-error>
      }
    </mat-form-field>
  </span>
} @else {
  <span>
    <mat-form-field [ngStyle]="styles" subscriptSizing="dynamic" appearance="fill">
      @if (prefixIcon) {
        <mat-icon matPrefix>{{ prefixIcon }}</mat-icon>
      }
      <mat-label>{{ placeholder }}</mat-label>
      <mat-select [value]="value" [placeholder]="placeholder" (selectionChange)="emitEvent($event)" [disabled]="disabled">
        @for (item of items; track trackByItem($index)) {
          <mat-option [value]="item.value">
            {{ item.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (error) {
      <form-error [error]="error" [ngStyle]="{ margin: '10px 0' }"></form-error>
    }
  </span>
}
